import React from "react";
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import "./about.styles.css";
import Profile from "../../assets/img/profile/profile-pic.webp";
import Image from "react-bootstrap/Image";
import Button from "react-bootstrap/Button";

const About = () => {
  return (
    <div>
      <div className="about">
        <h1 className=" text-center font-details pb-3">ABOUT ME</h1>
        <Container>
          <Row className="pt-3 pb-5 align-items-center">
            <Col xs={12} md={6}>
              <Row className="justify-content-center mb-2 mr-2 ">
                <Image className="profile justify-content-end" alt="profile" src={Profile} thumbnail fluid />
              </Row>
            </Col>
            <Col xs={12} md={6}>
              <Row className=" align-items-start p-2 my-details rounded">
                Hi there! I am <strong>&nbsp;Abhinav Nigam</strong>
                I'm an enthusiastic web developer with over 7+ years of experiences in wide range of applications in different ecosystems and domains.
                <br />
                I'm a Javascript lover, like sarcasm, love to share my knowledge, views and help the developer community.
                <br />
                My main areas of expertise are:
                <ul>
                  <li>Javascript</li>
                  <li>Typescript</li>
                  <li>React</li>
                  <li>Angular</li>
                  <li>HTML5</li>
                  <li>CSS3</li>
                  <li>Webpack</li>
                </ul>
                <br />
                <div>
                  <Col className="d-flex justify-content-center flex-wrap">
                    <div>
                      <a href="https://drive.google.com/file/d/1Os61PWhCmafOCzAclnBQ5AM6AGY6p82M/view?usp=sharing" target="_blank" rel="noopener noreferrer">
                        <Button className="m-2" variant="outline-success">
                          My Resume
                    </Button>
                      </a>
                    </div>
                    <div>
                      <a href="https://github.com/abhinavnigam2207" target="_blank" rel="noopener noreferrer">
                        <Button className="m-2" variant="outline-dark">
                          GitHub
                    </Button>
                      </a>
                    </div>
                    <div>
                      <a href="https://dev.to/abhinavnigam2207" target="_blank" rel="noopener noreferrer">
                        <Button className="m-2" variant="outline-primary">
                          DevTo
                    </Button>
                      </a>
                    </div>
                    <div>
                      <a href="https://www.linkedin.com/in/abhinavnigam2207" target="_blank" rel="noopener noreferrer">
                        <Button className="m-2" variant="outline-info">
                          LinkedIn
                    </Button>
                      </a>
                    </div>
                  </Col>
                </div>
              </Row>

            </Col>
          </Row>
        </Container>
      </div>
    </div>
  );
};

export default About;
